module.exports = __webpack_public_path__ + "img/vertical_4_2_7016.aa317d08.png";